import Yup from "./validations"
var titleRegex = /^[A-Za-z0-9 üÜöÖçÇşŞıİğĞ]*$/;
export const TrackSchema = Yup.object().shape({
    name: Yup.string().required().max(255),
    genre: Yup.string().required(),
    description: Yup.string().min(10).required(),
    source: Yup.string(),
    cover: Yup.string().required(),
    youtube_url: Yup.string().url(),
});